import React, { useEffect, useMemo } from "react";
import { map } from "lodash";
import { useSignal } from "@preact/signals-react";
import { DEFAULT_IMG_LIST_LEN } from "imagica-corekit/dist/cases/util/ViewBuilderImgUtil";
import { Img } from "../../ImgV2/Img";
import styles from "./ImgList.module.scss";
export function ImgList(props) {
  var listLen = props.list.length;
  var showNum = useSignal(DEFAULT_IMG_LIST_LEN);
  var showFold = showNum.value > DEFAULT_IMG_LIST_LEN && listLen > DEFAULT_IMG_LIST_LEN;
  var imgs = useMemo(function () {
    var lackOfLen = DEFAULT_IMG_LIST_LEN - listLen;
    var isLackOfImg = lackOfLen > 0;
    if (listLen > 0 && isLackOfImg) {
      // 这里listLen - 1是把作为源key的数据减掉
      var listImgs = getLackOfImgs(props.list, listLen - 1);
      // 这里lackOfLen + 1是把作为源key的数据算上
      var newArr = Array(lackOfLen + 1).fill(props.list[listLen - 1]);
      var lackOfImgs = getLackOfImgs(newArr, newArr.length, isLackOfImg);
      return [].concat(listImgs, lackOfImgs);
    }
    return getLackOfImgs(props.list, showNum.value);
  }, [showNum.value, props.list]);
  function getLackOfImgs(list, len, isLack) {
    return list.slice(0, len).map(function (i, idx) {
      return {
        imgKey: i,
        lackOfIdx: isLack ? idx : -1
      };
    });
  }
  var handleShow = function handleShow() {
    showNum.value += DEFAULT_IMG_LIST_LEN;
  };
  var handleFold = function handleFold() {
    showNum.value = DEFAULT_IMG_LIST_LEN;
  };
  useEffect(function () {
    showNum.value = DEFAULT_IMG_LIST_LEN;
  }, [props.list]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.imgListWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.placeImages
  }, map(imgs, function (item, index) {
    return /*#__PURE__*/React.createElement(Img, {
      key: index,
      className: "touristAttractionPlaceImg",
      imgKey: item.imgKey,
      lackOfIdx: item.lackOfIdx
    });
  }), showNum.value < listLen && /*#__PURE__*/React.createElement("div", {
    className: styles.imagesCount,
    onClick: function onClick() {
      return handleShow();
    }
  }, "+ ".concat(listLen - showNum.value))), showFold && /*#__PURE__*/React.createElement("div", {
    className: styles.fold
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.foldButton,
    onClick: function onClick() {
      return handleFold();
    }
  }, "fold")));
}